import React, { useEffect, useState } from "react";
import { Col, Form, Input, Modal, theme, Row, Divider } from "antd";
import { POST, PATCH } from "../../../frameworks/HttpClient";
import { URL_SETTING } from "../../../constants/urls";
import ErrorMessages from "../../../common/ErrorMessages";

export default function DeliverCompanyListModal(props) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { open, onClose, target, onUpdate } = props;
  const [errorMessages, setErrorMessages] = useState(null);

  const { TextArea } = Input;


  useEffect(() => {
    if (target) {
      form.setFieldsValue(target);
    } else {
      form.resetFields();
    }
  }, [open]);

  const {
    token: { colorWarning, colorSuccess },
  } = theme.useToken();

  const handleOK = async () => {
    setLoading(true);
    setErrorMessages(null);
    try {
      const data = await form.validateFields();
      if (target?.id) {
        await PATCH(`${URL_SETTING.DELIVER}${target.id}/`, data);
      } else {
        await POST(URL_SETTING.DELIVER, data);
      }
      onUpdate();
    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    setErrorMessages(null)
  },[open])

  return (
    <Modal
      open={open}
      onCancel={onClose}
      okText={target ? "แก้ไข" : "เพิ่ม"}
      cancelText="ยกเลิก"
      title={target ? "แก้ไขบริษัทขนส่ง" : "เพิ่มบริษัทขนส่ง"}
      width={550}
      onOk={handleOK}
      destroyOnClose
      centered
      okButtonProps={{
        style: { backgroundColor: target ? colorWarning : colorSuccess },
        loading,
      }}
    >
      <ErrorMessages message={errorMessages} />

      <Form form={form} layout="vertical" style={{ padding: "10px 20px" }}>
        <Row gutter={16}
        style={{display: "flex" , justifyContent: "space-between" }}
        >
          <Col span={8}>
            <Form.Item
              label="รหัส"
              name="code"
              rules={[{ required: true, message: "กรุณากรอก รหัส Packing" }]}
            >
              <Input placeholder="รหัส"/>
            </Form.Item>
          </Col>
          <Col span={16}>
            <Form.Item
              label="ชื่อบริษัท"
              name="name"
              rules={[{ required: true, message : 'กรุณากรอกข้อมูล' }]}
            >
              <Input placeholder="ชื่อบริษัท"/>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="ที่อยู่"
              name="address"
              rules={[{ required: true, message : 'กรุณากรอกข้อมูล'}]}
            >
              <Input.TextArea autoSize={{ minRows: 2, maxRows: 4 }} placeholder="ที่อยู่"/>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="Email"
              name="email"
              rules={[{ required: false}]}
            >
              <Input placeholder="Email"/>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="หมายเหตุ"
              name="note"
              rules={[{ required: false }]}
            >
              <TextArea autoSize={{ minRows: 2, maxRows: 4 }} placeholder="หมายเหตุ"/>
            </Form.Item>
          </Col>
          <Divider>ข้อมูลผู้ติดต่อ</Divider>

          <Col span={16}>
            <Form.Item
              label="ชื่อผู้ติดต่อ"
              name="contact"
              rules={[{ required: true, message: "กรุณากรอกชื่อผู้ติดต่อ"  }]}
            >
              <Input placeholder="ชื่อผู้ติดต่อ"/>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="เบอร์โทรศัพท์"
              name="phone"
              rules={[{ required: false, message: "กรุณากรอกเบอร์โทรศัพท์" }]}
            >
              <Input placeholder="เบอร์โทรศัพท์"/>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
